import { FC } from "react";

import styles from "./styles/SelectDrawingTool.module.css";

export type DrawingTab = "all" | "current";

interface Props {
  active: DrawingTab;
  currentCount: number;
  onChange: (tab: DrawingTab) => void;
}

export const DrawingTabs: FC<Props> = ({ active, currentCount, onChange }) => (
  <div className={styles.tabs}>
    <button
      className={`${styles.tab} ${active === "current" ? styles.tabActive : ""}`}
      onClick={() => onChange("current")}
    >
      Current ({currentCount})
    </button>
    <button
      className={`${styles.tab} ${active === "all" ? styles.tabActive : ""}`}
      onClick={() => onChange("all")}
    >
      All
    </button>
  </div>
);
